module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li class="charts-list__item charts-list__item--wide">\n		'+
((__t=( obj.label ))==null?'':__t)+
'\n	<div class="m-table">\n		<table>\n			<thead>\n				<tr>\n					<th>nr</th>\n					<th>name</th>\n					<th>value</th>\n				</tr>\n			</thead>\n			<tbody>\n\n    	';
 for(var i = 0; i < obj.value.length; ++i) { 
__p+='\n					<tr>\n					<td>'+
((__t=( getRegKey(i) ))==null?'':__t)+
'</td>\n					<td>'+
((__t=( getLabel(i) ))==null?'':__t)+
'</td>\n					<td>						\n					';
 if (obj.value[i].editable) { 
__p+='\n						<span class="js-register-edit" data-reg-key="'+
((__t=( getRegKey(i) ))==null?'':__t)+
'" data-reg-value="'+
((__t=( getRawValue(i) ))==null?'':__t)+
'">'+
((__t=( getValue(i) ))==null?'':__t)+
'</span>\n					';
 } else { 
__p+='\n					'+
((__t=( getValue(i) ))==null?'':__t)+
'\n					';
 } 
__p+='\n					</td>\n				</tr>\n				';
 } 
__p+='\n\n			</tbody>\n		</table>\n	</div>\n</li>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/device-status/show/templates/table.html
// module id = 430
// module chunks = 0